<!-- main app container -->
<div *ngIf="isLoading$  | async" class="lottie-overlay">
        <ng-lottie [options]="options"></ng-lottie>
</div>
<!-- <app-alert></app-alert> -->
<router-outlet *ngIf="showContent"></router-outlet>
<app-public-footer></app-public-footer>